const GWP_DISCOUNT_TITLE = 'GWP';

const isDiscounted = (item) => item.line_price === 0 || item.discounts.some((discount) => discount.title === GWP_DISCOUNT_TITLE);
const hasMatchingGift = (item, gift) => item.product_id === gift.product_id && isDiscounted(item);

export const isGiftQualified = (gift, gifts, items) => {
  // If we've already got enough gifts with the same limit return false
  const limit = gift.limit ?? 0;

  const numberOfGiftsWithMatchingLimit = items.filter((item) => {
    const matchingGift = gifts.find((_gift) => hasMatchingGift(item, _gift));
    return matchingGift && matchingGift.limit === limit && isDiscounted(item);
  }).length;

  if (limit > 0 && numberOfGiftsWithMatchingLimit >= limit) return false;

  // If the minimum spend is not met return false
  const minimumSpend = gift.minimum_spend ?? 0;

  const includedProducts = gift.include_products ?? [];
  const excludedProducts = gift.exclude_products ?? [];

  // eslint-disable-next-line no-nested-ternary
  const qualifyingItems = includedProducts.length
    ? items.filter((item) => includedProducts.some((product) => product.id === item.product_id))
    : excludedProducts.length
    ? items.filter((item) => !excludedProducts.some((product) => product.id === item.product_id))
    : items;

  const totalSpend = qualifyingItems.reduce((total, qualifyingItem) => total + qualifyingItem.final_line_price, 0);

  return totalSpend >= minimumSpend;
};

export const getGiftWithPurchase = (gifts, items) => {
  const qualifiedGifts = [];
  const claimedGifts = [];
  const excludedGifts = [];
  const remainingSpend = [];

  gifts.forEach((gift) => {
    // If this gift is already in the cart return false
    const giftInCart = items.some((item) => hasMatchingGift(item, gift) && isDiscounted(item));

    if (giftInCart) {
      claimedGifts.push(gift);
      return;
    }

    // If we've already got enough gifts with the same limit return false
    const limit = gift.limit ?? 0;

    const numberOfGiftsWithMatchingLimit = items.filter((item) => {
      const matchingGift = gifts.find((_gift) => hasMatchingGift(item, _gift));
      return matchingGift && matchingGift.limit === limit && isDiscounted(item);
    }).length;

    if (limit > 0 && numberOfGiftsWithMatchingLimit >= limit) return false;

    // If the minimum spend is not met return false
    const minimumSpend = gift.minimum_spend ?? 0;

    const includedProducts = gift.include_products ?? [];
    const excludedProducts = gift.exclude_products ?? [];

    // eslint-disable-next-line no-nested-ternary
    const qualifyingItems = includedProducts.length
      ? items.filter((item) => includedProducts.some((product) => product.id === item.product_id))
      : excludedProducts.length
      ? items.filter((item) => !excludedProducts.some((product) => product.id === item.product_id))
      : items;

    const totalSpend = qualifyingItems.reduce((total, qualifyingItem) => total + qualifyingItem.final_line_price, 0);

    if (totalSpend < minimumSpend) {
      excludedGifts.push(gift);
      remainingSpend.push(minimumSpend - totalSpend);
    } else {
      qualifiedGifts.push(gift);
    }
  });

  return {
    gifts: qualifiedGifts,
    excludedGifts,
    claimedGifts,
    remainingSpend,
  };
};
